export enum SSEStatus {
    Initial = 'Initial',
    Connecting = 'Connecting',
    // We'll give the server a short time to replay the past events.
    // This prevents flashing if we're connecting to an existing stream that has a bunch of events to replay.
    WaitingForReplay = 'WaitingForReplay',
    Connected = 'Connected',
    Error = 'Error',
}